import classNames from "classnames";
import React from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

const Footer = ({ view }) => {
  const location = useLocation();
  const locationIsRoot =
    location.pathname === "/" || location.pathname.includes("/cities");
  const footerClasses = classNames("footer", {
    open: view === "LIST_VIEW" && locationIsRoot,
    closed: view === "MAP_VIEW" && locationIsRoot,
  });

  return (
    <footer className={footerClasses}>
      <p>
        &copy; {new Date().getFullYear()} VegifyIt
        {" | "}
        <a className="footer-link" href="/about">
          About
        </a>
        {" | "}
        <a className="footer-link" href="/contact">
          Contact
        </a>
        {" | "}
        <a className="footer-link" href="/events">
          Events
        </a>
        {" | "}
        <a className="footer-link" href="/organizing-a-festival">
          Organizing a Festival
        </a>
      </p>
    </footer>
  );
};

const mapStateToProps = (state) => ({
  view: state.results.view,
});
export default connect(mapStateToProps, {})(Footer);
